export const JOURNEY_MODE_RETURN = "JOURNEY_MODE_RETURN";
export const JOURNEY_MODE_SINGLE = "JOURNEY_MODE_SINGLE";
